import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "../shared/styles/palette.css";
import "../shared/styles/styles.css";

createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
